import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { getBackgroundColorPassung } from '../../helpers'

const formatValue = (value) =>
  Number(value).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

const Row = ({ row, valueColor }) => (
  <div className='flex items-center gap-x-2 py-0.5'>
    <span
      className='inline-block h-2.5 w-2.5 flex-shrink-0 rounded-full border'
      style={{
        backgroundColor: row.color,
        borderColor: row.color,
        borderStyle: row.isProfile ? 'dashed' : 'solid'
      }}
    />
    <span className='min-w-0 flex-1 truncate text-sm text-gray-700'>
      {row.label}
    </span>
    <span
      className='flex-shrink-0 text-sm font-semibold tabular-nums'
      style={{ color: valueColor || '#111827' }}
    >
      {formatValue(row.value)}
    </span>
  </div>
)

Row.propTypes = {
  row: PropTypes.shape({
    label: PropTypes.string,
    color: PropTypes.string,
    value: PropTypes.number,
    isProfile: PropTypes.bool
  }).isRequired,
  valueColor: PropTypes.string
}

const DimensionOverlay = ({ hovered, dimensionLabel }) => {
  const { t } = useTranslation()

  if (!hovered || !hovered.rows.length) return null

  const profiles = hovered.rows.filter((row) => row.isProfile)
  const candidates = hovered.rows
    .filter((row) => !row.isProfile)
    .sort((a, b) => b.value - a.value)

  // Color candidate values by fit to the requirement profile's optimal for this
  // dimension — same red/yellow/green logic as the linear list view. Without a
  // profile there is no reference, so values stay neutral.
  const optimal = profiles.length ? profiles[0].value : null
  const getValueColor = (value) =>
    optimal == null
      ? undefined
      : getBackgroundColorPassung(100 - Math.abs(value - optimal), false)

  return (
    <div className='pointer-events-none absolute left-0 top-1/2 z-10 w-64 max-w-xs -translate-y-1/2 rounded-lg border border-gray-200 bg-white/95 p-4 shadow-lg backdrop-blur-sm'>
      <p className='mb-2 border-b border-gray-100 pb-2 text-sm font-bold text-gray-900'>
        {dimensionLabel}
      </p>

      {!!profiles.length && (
        <div className='mb-2 border-b border-dashed border-gray-200 pb-2'>
          <p className='mb-1 text-xs font-medium uppercase tracking-wide text-gray-400'>
            {t('radar_chart.overlay.requirement_profiles')}
          </p>
          {profiles.map((row) => (
            <Row key={row.datasetIndex} row={row} />
          ))}
        </div>
      )}

      <p className='mb-1 text-xs font-medium uppercase tracking-wide text-gray-400'>
        {t('radar_chart.overlay.candidates')}
      </p>
      {candidates.map((row) => (
        <Row
          key={row.datasetIndex}
          row={row}
          valueColor={getValueColor(row.value)}
        />
      ))}
    </div>
  )
}

DimensionOverlay.propTypes = {
  hovered: PropTypes.shape({
    index: PropTypes.number,
    rows: PropTypes.array
  }),
  dimensionLabel: PropTypes.string
}

export default DimensionOverlay
